/**The version defined in package.json and declared in vite.config.ts */
declare const __APP_VERSION__: string
/**App version defined in package.json */
export const AppVersion: string = __APP_VERSION__
